// Standalone CDN URL processor for rendered CMS HTML (blog posts,
// HTMLContent). Lives outside the editor barrel on purpose: site components
// import THIS module — importing anything from aldoo-ra/HtmlEditor (index)
// pulls the entire editor (toolbar, plugins, MediaLibrary) into the page
// bundle.
import { url } from "aldoo-ra/CMS/url"

export const updateCDNUrls = (htmlString) => {
  if (!htmlString || typeof htmlString !== "string") return ""

  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, "text/html")
  const elements = doc.querySelectorAll("[cdn]")

  elements.forEach((element) => {
    const cdnValue = element.getAttribute("cdn")
    if (cdnValue) {
      const fullUrl = url(cdnValue)
      if (element.tagName.toLowerCase() === "a") {
        element.setAttribute("href", fullUrl)
      } else {
        element.setAttribute("src", fullUrl)
      }
    }
  })

  return doc.body.innerHTML
}
